const $ = window.jQuery;

/*
	Enable search category buttons that submit their search form with a category
	filter. They can't be real [type="submit"] buttons because users who press the
	Enter key will trigger the first submit button in the form, and since the
	category buttons come first in the form, Enter would apply a surprise category
	filter to the results.
 */
$('.js-search-form').each(function () {
	const $form = $(this)

	$('.js-search-category-button', $form).click(function () {
		const $btn = $(this)
		const id = $btn.attr('data-category-id')
		$(document.createElement('input'))
			.attr({
				name: 'cat',
				value: id,
				type: 'hidden'
			})
			.appendTo($form)

		$form.submit()
	})
})
